import React from "react";
import { useNavigate } from "react-router-dom";

const TitleComponent = ({ value, item }: { value: string; item: any }) => {
  const navigate = useNavigate()
  return (
    <div
      onClick={(e)=>{
        navigate(`./show/${item.id}`);
        // navigate(`/inventories/${inventory.id}`);
        e.preventDefault();
      }}
    className="flex flex-col items-start gap-2">
      <span className="text-[#747575] text-base font-IRANSansMedium font-medium ">
        {item?.description ?? ""}
      </span>
      <div className="flex flex-row items-center justify-start gap-1">
        <span className="text-black text-sm font-IRANSans font-medium">
          {item?.payer?.accountingCode ?? ""}
        </span>
        <span className="px-2 py-[1px] bg-[#D6E4FF] text-blue-1 rounded font-IRANSans font-xs text-xs">
          #
        </span>
        <span className="text-[#424242] text-xs font-IRANSans font-normal">
          {item.payer_type === "factor" ? item.payer?.Person.nickName ?? "" : item?.payer?.nickName ?? ""}
        </span>
      </div>
    </div>
  );
};

export default TitleComponent;
